import { getAuth, signOut } from 'firebase/auth';

function SignOut({ signOut }) {
    return (
        <button className="sign-out" onClick={signOut}>Sign Out</button>
    )
  }
export default SignOut
